import { InfographicConfig } from "../types";

const antarcticaBridgeInfographicConfig: InfographicConfig = {
  groups: [
    {
      id: "pre-cruise",
      icon: "pre-cruise",
      steps: [
        {
          id: "pre-door-2-door",
          inclusions: ["PreDoor2Door"],
          fallbackInclusion: "PreDoor2Door"
        },
        {
          id: "pre-air",
          inclusions: [
            "InternationalFlights",
            "BusinessFlights",
            "EconomyFlights",
            "EconomyFlightsWithUpgrade",
            "BusinessUpgraded"
          ],
          fallbackInclusion: "InternationalFlights"
        },
        {
          id: "pre-hotel",
          inclusions: ["PreInCountryFlight", "PreHotel"],
          overrideIcon: {
            strategy: "all-active-inclusions",
            inclusions: ["PreInCountryFlight", "PreHotel"],
            icon: "hotel-charter"
          }
        },
        {
          id: "pre-antarctica-bridge",
          inclusions: ["PreAntarcticaBridgeFlight"]
        }
      ]
    },
    {
      id: "cruise",
      icon: "ship-lateral",
      steps: [
        {
          id: "cruise",
          inclusions: [
            "FoodAndBeverage",
            "Butler",
            "SpecialEquipments",
            "ExpeditionCruiseExtras"
          ],
          overrideIcon: "ship-lateral"
        }
      ]
    },
    {
      id: "shorex",
      icon: "shore-excursions",
      steps: [
        {
          id: "shorex",
          inclusions: ["FreeShorex", "FreeShorexExpedition"]
        }
      ]
    },
    {
      id: "post-cruise",
      icon: "post-cruise",
      steps: [
        {
          id: "post-antarctica-bridge",
          inclusions: ["PostAntarcticaBridgeFlight"]
        },
        {
          id: "post-hotel",
          inclusions: ["PostHotel", "PostInCountryFlight"],
          overrideIcon: {
            strategy: "all-active-inclusions",
            inclusions: ["PostHotel", "PostInCountryFlight"],
            icon: "hotel-charter"
          }
        },
        {
          id: "post-air",
          inclusions: [
            "InternationalFlights",
            "BusinessFlights",
            "EconomyFlights",
            "EconomyFlightsWithUpgrade",
            "BusinessUpgraded"
          ],
          fallbackInclusion: "InternationalFlights"
        },
        {
          id: "post-door-2-door",
          inclusions: ["PostDoor2Door"],
          fallbackInclusion: "PostDoor2Door"
        }
      ]
    }
  ]
};

export default antarcticaBridgeInfographicConfig;
